package uz.ferro.erp.feature.product.model

import kotlinx.serialization.Serializable
import uz.ferro.erp.feature.country.model.Country

@Serializable
data class CountryProducts(
    val country: Country,
    val products: List<Product>
)
